module.exports = __webpack_public_path__ + "static/media/pattern_home.447d0a8a.svg";